import { BreakpointObserver } from '@angular/cdk/layout';
import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  Inject,
  AfterViewInit,
  ElementRef,
  HostListener,
  NgZone,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { controllers } from 'chart.js';
import {
  BehaviorSubject,
  filter,
  firstValueFrom,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import { RecommendationsFormComponent } from 'src/app/customers/community/recommandations-form/recommandations-form.component';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import {
  CommunityProduct,
  CommunityProductPagination,
} from 'src/app/shareModule/models/community-product.model';
import { User } from 'src/app/shareModule/models/user.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectAllCommunityProducts } from 'src/app/shareModule/states/community-product';
import {
  loadIndividualProducts,
  selectIndividualProducts,
  selectIndividualProductsLoading,
} from 'src/app/shareModule/states/individual-all-product';
import { loadUser, selectUser } from 'src/app/shareModule/states/user-details';
import { environment } from 'src/environments/environment';

import { ToastrService } from 'ngx-toastr';
import { GoogleMapsService } from 'src/app/google-maps.service';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { UploadEditedImageComponent } from 'src/app/community/upload-edited-image/upload-edited-image.component';
import {
  EditedImageBatchResult,
  EditedImageResult,
} from 'src/app/community/upload-edited-image/upload-edited-image.types';
import { SearchModalComponent } from 'src/app/search-modal/search-modal.component';




@Component({
  selector: 'app-individual-all-product',
  templateUrl: './individual-all-product.component.html',
  styleUrls: ['./individual-all-product.component.scss'],
})
export class IndividualAllProductComponent
  implements OnInit, OnDestroy, AfterViewInit {
  private destroy$ = new Subject<void>();
  @ViewChild('marketplace') marketplacePage: MarketplacePageComponent;

  public selectedMemberRegion = '';
  public imgUrl = environment.ImageUrl;
  public isLogin = 0;
  public userId: Number;
  public userRegionId: any;
  public search = '';
  // public loading = false;

  carouselOptions: any = { spaceBetween: 10, slidesPerView: 'auto' };
  allProductByRegionViewTabsFilter: any = [];
  allProduct: CommunityProductPagination = {
    currentPage: 1,
    data: [],
    lastPage: 1,
    totalCount: 0,
  };
  allProductDoorstep: CommunityProductPagination = {
    currentPage: 1,
    data: [],
    lastPage: 1,
    totalCount: 0,
  };
  allProductByRegion: any = [];
  allProductByRegionViewTabs: any = [];
  allProductPopular: any = [];
  adsList: any;
  latLong: any = {};
  viewTabs = false;
  readMore = false;
  public width: any = '';
  public isMobile: any = '';
  subscriptions: Subscription[] = [];

  public tabs: any = [];

  basedProduct: string = 'shop_promote';

  carouselOptionsCate: any = {
    spaceBetween: 5,
    slidesPerView: 'auto',
    pagination: false,
  };
  carouselOptionsList: any = {
    spaceBetween: 0,
    slidesPerView: 1,
    // grid: {
    //   rows: 3,
    //   columns: 3,
    //   fill: 'row',

    // },

    // pagination: false,e
  };
  constructor(

    public roleService: RoleService,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private memberNotificationService: MemberNotificationService,
    private store: Store<AppState>,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private modalService: NgbModal,
    private breakPointObserver: BreakpointObserver,
    private toastr: ToastrService,
    private googleMapsService: GoogleMapsService,
    @Inject('WINDOW') private window: any,
    private cdr: ChangeDetectorRef
  ) { }

  private deviceType = 1;
  private breakPointObserverSubscription: Subscription | null = null;
  public isLoadingAllProduct: boolean = false;
  public isLoadingAllProductMore: boolean = false;
  public isLoadingDoorstepMore: boolean = false;

  private getDeviceRowLength() {
    if (this.sharedService.isBrowser()) {
      this.breakPointObserverSubscription = this.breakPointObserver
        .observe([
          '(max-width: 767px)',
          '(min-width: 768px) and (max-width: 991px)',
          '(min-width: 992px) and (max-width: 1199px)',
        ])
        .pipe(takeUntil(this.destroy$))
        .subscribe((result) => {
          if (result.breakpoints['(max-width: 767px)']) {
            this.deviceType = 2;
          } else if (
            result.breakpoints['(min-width: 768px) and (max-width: 991px)']
          ) {
            this.deviceType = 3;
          } else if (
            result.breakpoints['(min-width: 992px) and (max-width: 1199px)']
          ) {
            this.deviceType = 4;
          } else {
            this.deviceType = 5;
          }
        });
    }
  }

  ///////////////////////////////// code related to tabs management ///////////////////////////////////////////////
  public hiddenCategoryTab = '';
  private userData = null;


  private getUserTabPreferences() {
    console.log('getting user tab preferences');
    this.viewTabs = false;
    if (this.local.getUser()) {
      this.store.select(selectUser)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          error: (err) => {
            console.error(err);
            this.viewTabs = true;
          },
          next: (user) => {
            this.viewTabs = true;
            this.hiddenCategoryTab = user?.hiddenCategoryTab;
            this.userData = user;
            this.tabs = this.totalTabs.map((x) => {
              x['condition'] = true;
              return x;
            });
          },
        });
    } else {
      console.log('user not logged in');
      this.tabs = this.totalTabs;
      this.viewTabs = true;
    }
  }

  public mapCategories = [];


  public timeout1: any;
  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.loadUserLoadsProducts('latest')
      this.width = this.window.innerWidth;
      this.isMobile = this.width < 991;


      this.route.params.subscribe((params) => {
        if (params['slug'] && params['slug'].includes('-')) {
          this.timeout1 = setTimeout(() => {
            this.viewProductDetails({ id: params['slug'].split('-').pop() });
          }, 1000);
        }
      });

      this.servicesSelectedSubRegionSubscription =
        this.sharedService.servicesShowingSubRegion.subscribe(
          (subRegion: any) => {
            //console.log("subscription listened")
            this.servicesSelectedSubRegion = subRegion.subRegionId + '';
            this.handleLoadProducts();
          }
        );
      //this.loadMapCategory('all');
      this.sharedService.individualProductsPageSubject
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          if (data.type == 'search') {
            this.search = data.val;
            this.handleLoadProducts();
          }
        });
    }
    this.commonService.categoryList
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.mapCategories = structuredClone(response);
        for (const cat of this.mapCategories) {
          if (cat?.name?.toLowerCase()?.includes('food')) {
            this.loadMapCategory(cat);
            break;
          }
        }


        const move = [] //moving pets and fitness to the last
        for (let i = 0; i < this.mapCategories.length; i++) {
          const cat = this.mapCategories[i]
          if (cat?.name?.toLowerCase()?.trim() == 'pets' || cat?.name?.toLowerCase()?.trim() == 'fitness') {
            move.push(cat)
            this.mapCategories[i] = null
            if (move.length == 2) {
              break;
            }
          }

        }
        console.log({ move })
        this.mapCategories = [...this.mapCategories.filter(cat => cat), ...move];




      });
  }
  ngAfterViewInit(): void {
    this.getUserTabPreferences();
    this.getDeviceRowLength();
    this.loadMemberProducts();
    this.loadMoreDoorsteps();
    this.initializeUserDetails();
    this.loadUserRegionAds();
    this._getSubRegionImages();
    this.cdr.detectChanges();
  }
  public servicesSelectedSubRegionSubscription: Subscription | null = null;

  ngOnDestroy(): void {
    // console.log('[Start Destroy] Individual All Product')
    this.local.clearTimeout(this.timeout1)
    this.local.clearTimeout(this.timeout3)
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.breakPointObserverSubscription?.unsubscribe();
    this.servicesSelectedSubRegionSubscription?.unsubscribe();
    //this.googleMapsService.removeCurrentMap();
    this._roleSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    // console.log('[End Destroy] Individual All Product')
  }
  public userRegionName = '';
  private _roleSubscription: Subscription | null = null;

  private initializeUserDetails(): void {
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isUserAdmin = this.roleService?.roles?.userType.includes('ADMIN')
    })



    const userDetailsSubscription = this.local
      .getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (user: User) => {
        if (user?.id) {

          this.isLogin = 1;
          this.userId = user.id;
          this.userRegionId = user.region;

          this.getFavoriteProducts(true);

          // this.store.dispatch(loadIndividualProducts({ categoryId: '', subRegionId: user?.region, search: this.search }));
          this.handleLoadProducts();
          this.latLong = user.latLong
        } else {
          this.isLogin = 0;
        }
      });



    this.commonService.subRegionListBaseProductObserver
      .pipe(takeUntil(this.destroy$))
      .subscribe((region) => {
        this.userRegionName = region.filter(r => r.subRegionId == this.userRegionId)[0]?.name;
      })

    this.subscriptions.push(userDetailsSubscription);
  }

  public getFavoriteProducts(init = false) {
    this.customerService
      .getFavoriteProducts({
        userId: this.userId,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: any) => {
        if (init) {
          this.tabs.push({
            title: 'Favorites',
            condition: !this.hiddenCategoryTab?.includes('Favorites'),
          });

          this.viewTabs = true;
        }
        this.allProduct.data = resp.body;
        this.cdr.detectChanges();
      });
  }





  private categoryIconMap: Map<string, string> = new Map<string, string>();
  private shouldMapRefresh = false;

  public searchSuggestions = []

  public openSearchModal(value = '') {
  

    this.searchSuggestions = [];
    // this.maps.search = text;
    // this.isSearchFromHomepage = true;
    const ref = this.modalService.open(SearchModalComponent, {size: 'lg'});
    ref.componentInstance.maps = {
      search: value ||  this.search,
      all: true,
      postalCode: 'All',
      radius: 5,
      products: [],
      productsToCompare: [],
      subCategoriesBasedOnKeyWords: [],
      subcats: [],
      fetchedFaqs: [],
      filter: '',
    }
    ref.componentInstance.viewProductDetails
    .pipe(takeUntil(this.destroy$))
    .subscribe(productData =>{
      this.viewProductDetails(productData)
    })
    
  }
  public getSearchSuggestions(event) {
    const isAscii = event.key?.length === 1; //called for backspace and stuff so not reliable

    const term = event.target.value;
    if (term.length + (isAscii ? 1 : 0) < 3) {
      this.searchSuggestions = [];
      return;
    }
    this.auth
      .getSearchSuggestions(term + (isAscii ? event.key : ''))
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.searchSuggestions = (data.body ?? []).slice(0, 4);
          this.cdr.detectChanges();
         // console.log(this.searchSuggestions);
        },
        error: console.error,
      });
  }

  private prepProductCategoryImages(categoryData) {
    for (const cat of categoryData) {
      this.categoryIconMap.set(cat.id, cat.image);
      for (const subCat of cat.subCategory) {
        this.categoryIconMap.set(subCat.categorieChildId, cat.image);
      }
    }

  }

  private sliceInto(arr, oneSize = 5) {
    const rv = [];
    for (let i = 0; i < arr.length; i += oneSize) {
      rv.push(arr.slice(i, i + 5));
    }
    return rv;
  }
  public formateDate(timeStamp) {
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    const diff = now - timeStamp;

    const minutes = Math.floor(diff / 60);
    const hours = Math.floor(diff / 3600);
    const days = Math.floor(diff / 86400);
    const months = Math.floor(diff / (86400 * 30));
    const years = Math.floor(diff / (86400 * 365));

    if (diff < 60) {
      return 'Listed just now';
    } else if (minutes < 60) {
      return `Listed ${minutes} min`;
    } else if (hours < 24) {
      return `Listed ${hours} hr${hours !== 1 ? 's' : ''}`;
    } else if (days < 30) {
      return `Listed ${days} Day${days !== 1 ? 's' : ''}`;
    } else if (days < 365) {
      return `Listed ${months} Mth${months !== 1 ? 's' : ''}`;
    } else {
      return `Listed ${years} Yr${years !== 1 ? 's' : ''}`;
    }

  }
  public mapData = []

  public areProductLoadedForOtherProducts = false; //this is for telling the ui if the already loaded products are fetched for others or normal
  private isProductLoadForOtherProductWithSameCategoryAnyRegion = false; //this is just used to tell if the products that are fetched are others or normal products on maps tab
  private loadOtherRegionSameCategoryProducts() {
    if (this.isProductLoadForOtherProductWithSameCategoryAnyRegion) {
      return; //this is done so that recursive infinite calls dont't comde
      ///DONOT MOVE OR REPLACE
    }
    const categoryId = this.selectedMapCategoryId == 'all'
      ? ''
      : ([
        ...this.mapSubCategories
          .filter((sb) => sb.isChecked)
          .map((sb) => sb.categorieChildId),
      ] as any);

    this.store.dispatch(
      loadIndividualProducts({
        categoryId,
        page: 1,
        basedProduct: 'shop_promote',
        search: this.search,
        orderBy: 'points',
        loadTags: true
      })
    );
    this.isProductLoadForOtherProductWithSameCategoryAnyRegion = true;

  }

  /*********************** Code related to  subregion image uploads *****************/



  ////////////////////////////////////////

  public subregionImageUploadId = 'subregion-upload-image'
  public subregionImageUploadIdCamera = 'subregion-upload-image-camera'
  public selectedRegionImageToUpload: File | null = null
  public selectedRegionImageToUploadBuffer = null


  private getActiveSubregionId() {
    let subRegionId = this.userRegionId;

    // used by the drop down above
    //select the region that is selected by the admin
    if (
      this.roleService?.roles?.userType.includes('ADMIN') &&
      this.servicesSelectedSubRegion
    ) {
      subRegionId = this.servicesSelectedSubRegion.id;
    }
    return subRegionId
  }
  public subregionImageUploadCurrentCaption = '';
  public currentCropInformationToBeSaved = null;
  public submitSubregionFileUpload() {
    if (!this.selectedRegionImageToUpload) {
      this.toastr.info("Please select an image first")
      return;
    }
    const uploadData = new FormData();
    uploadData.append('subregionId', this.getActiveSubregionId())
    uploadData.append('image', this.selectedRegionImageToUpload);
    uploadData.append('caption', this.subregionImageUploadCurrentCaption);
    uploadData.append('cropInformation', JSON.stringify(this.currentCropInformationToBeSaved));

    this.auth.uploadSubregionImage(uploadData)
      .subscribe({
        next: () => {
          this.toastr.success("Uploaded!")
          this.selectedRegionImageToUpload = null;
          this.selectedRegionImageToUploadBuffer = null;
          this.subregionImageUploadCurrentCaption = '';
          this.modalService.dismissAll();
          this._getSubRegionImages();

        },

        error: err => {
          this.toastr.error("Error something went wrong!");
          console.error(err)
        }
      })
  }





  public openUploadSubregionImageModal() {

    const modalRef = this.modalService.open(UploadEditedImageComponent, { size: 'sm', centered: true });
    // modalRef.shown.subscribe(() => this.initCropper())

    let topText = '';
    const user = this.local.getUser();

    if (user) {
      topText = this.commonService.getSubregionName(user.region);
    }
    modalRef.componentInstance.topText = topText;
    modalRef.result.then(async (res: EditedImageBatchResult) => {
      const images = res?.images ?? [];
      if (!images.length) {
        return;
      }

      let success = 0;
      let failed = 0;

      for (const image of images) {
        const uploadData = new FormData();
        uploadData.append('subregionId', this.getActiveSubregionId());
        uploadData.append('image', image.imageData);
        uploadData.append('caption', image.caption ?? '');
        if (image.cropInformation) {
          uploadData.append(
            'cropInformation',
            typeof image.cropInformation === 'string'
              ? image.cropInformation
              : JSON.stringify(image.cropInformation),
          );
        }

        try {
          await firstValueFrom(this.auth.uploadSubregionImage(uploadData));
          success++;
        } catch (error) {
          failed++;
          console.error(error);
        }
      }

      if (success) {
        this.toastr.success(
          `${success} image${success > 1 ? 's' : ''} uploaded successfully`,
        );
        this.modalService.dismissAll();
        this._getSubRegionImages();
      }
      if (failed) {
        this.toastr.error(
          `${failed} image${failed > 1 ? 's' : ''} failed to upload`,
        );
      }
    });
  }
  public subregionUploadedImage = []
  public showImagePopup(url, text = '', cropInfo = null) {

    this.modalService.dismissAll();
    const instance = this.modalService.open(ImageModalComponent, {
      size: "md",
      windowClass: "image-modal",
    });
    instance.componentInstance.imageSrc = environment.ImageUrl + url;
    instance.componentInstance.descr = text;
    instance.componentInstance.cropInformation = cropInfo

  }
  public isUserAdmin = false;
  public editUploadedImage(uploadImage) {
    const modalRef = this.modalService.open(UploadEditedImageComponent, { size: 'sm', centered: true });
    // modalRef.shown.subscribe(() => this.initCropper())

    let topText = '';
    const user = this.local.getUser();

    if (user) {
      topText = this.commonService.getSubregionName(user.region);
    }
    modalRef.componentInstance.topText = topText;
    modalRef.componentInstance.currentUploadCaption = uploadImage.caption;
    if (uploadImage.cropInformation && uploadImage.cropInformation != 'null' && uploadImage.cropInformation != 'undefined') {
      modalRef.componentInstance.cropInformation = "{}"
    }


    fetch(this.imgUrl + uploadImage.imageFile)
      .then(file => file.blob())
      .then(res => {

        const fileReader = new FileReader();
        fileReader.onload = () => {
          modalRef.componentInstance.initialImage = fileReader.result;
        };
        fileReader.readAsDataURL(res);

      })

    /**
    public convertedImageToShow: string | ArrayBuffer = null;

  @Input()
  public currentUploadCaption = '';

  @Input()
  public set cropInformation 

     */
    modalRef.result.then((res: EditedImageBatchResult) => {
      const image = res?.images?.[0];
      if (!image) {
        return;
      }
      this.auth
        .editUploadedImages(
          uploadImage.id,
          image.caption,
          JSON.stringify(image.cropInformation),
          image.imageData,
        )
        .subscribe({
          next: () => {
            this.toastr.success('Edited!');
            this._getSubRegionImages();
          },
          error: (err) => {
            this.toastr.error('Something went wrong');
            console.error(err);
          },
        });
    });

  }
  public deleteUploadedImage(uploadedImage) {
    this.local.confirmYesNo({ title: "Are you sure you want to delete this uploaded Image", text: '', icon: 'warning' })
      .then(
        res => {
          if (res.isConfirmed) {
            this.auth.deleteUploadedImages(uploadedImage.id).subscribe({
              next: () => {
                this.toastr.success("Deleted")
                this._getSubRegionImages();
              }
            })
          }
        }
      )
  }

  public get appUserId() {
    return this.local.getUser()?.id
  }

  private _getSubRegionImages() {
    this.auth.getSubRegionUploadedImages(this.getActiveSubregionId())
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: data => {
            this.subregionUploadedImage = data.body;
            this.areActionsVisibleOnAction = new Array(this.subregionUploadedImage.length);
            this.areActionsVisibleOnAction.fill(false);
            this.cdr.detectChanges();

          },
          error: err => {
            console.error(err);
          }
        }
      )
  }

  public toggleUploadRxn(type) {
    this.auth.toggleUploadReaction(this.currentSelectedPost?.id, type).subscribe(
      {
        next: () => {
          this._getSubRegionImages();
          this.toastr.success("Done");
          this.modalService.dismissAll();
        },
        error: err => {
          console.error(err);
          this.toastr.error("Error something went wrong while reacting")
        }
      }
    )

  }

  @ViewChild('confirmPostReaction')
  public confirmPostReactionModal: TemplateRef<any>

  private currentSelectedPost = null;
  public areActionsVisibleOnAction = []

  openConfrimReaction(post) {
    this.currentSelectedPost = post
    this.modalService.open(this.confirmPostReactionModal, { size: 'sm', centered: true })
  }
  /****************************************************************************** */

  private _mapProductDataSubscription: Subscription | null = null;
  private filterProductsToSameCategory(mapData) {
    //sometimes store dispaches are shown here that isn't in our category
    return mapData.filter(prod => this.categoryId.includes(prod.categoryId))
  }

  private loadMemberProducts(): void {
    this.store
      .pipe(select(selectIndividualProducts), takeUntil(this.destroy$))
      .subscribe((response: any) => {

        if (response.currentPage === 1) this.allProduct.data = [];
        if (response?.data) {
          this.mapData = structuredClone(
            response.data?.filter(
              (prod) =>
                prod &&
                !prod?.subRegionName?.trim()?.split(',')?.includes('all')
            )
          );
          this.mapData = this.filterProductsToSameCategory(this.mapData)

          if (this.mapData.length == 0 && this.sharedService.isBrowser() && !this.isProductLoadForOtherProductWithSameCategoryAnyRegion) {
            this.loadOtherRegionSameCategoryProducts(); //this must always be checked for recusrion problems
            return;
          }
          if (this.isProductLoadForOtherProductWithSameCategoryAnyRegion) {
            this.isProductLoadForOtherProductWithSameCategoryAnyRegion = false;
            this.areProductLoadedForOtherProducts = true; //the products fetched are not on the same region but others from d/t region
          } else {
            this.areProductLoadedForOtherProducts = false;
          }



          this.mapData = this.sliceInto(this.mapData, 5);

          this.mapData.sort(
            (v, y) =>
              (v.type == 'promote' ? 1 : 0) - (y.type == 'promote' ? 1 : 0)
          );

          for (const prod of this.mapData.flat()) {
            let verificationLikeCount = 0;
            if (prod.productVerficationsList) {
              for (const v of prod.productVerficationsList) {
                verificationLikeCount += v.likeCounts;
              }
            }

            prod.verificationLikeCount = verificationLikeCount; ///calculating once
          }

          this.commonService.categoryList
            .pipe(takeUntil(this.destroy$))
            .subscribe((response: any) => {
              if (this.sharedService.isBrowser()) {
                this.prepProductCategoryImages(response);
                //this.googleMapsService.setCategoryIconMap(this.categoryIconMap);
                //this.initMap(this.indexFilter == 'map' ? 'map_2' : 'map_1');
              }
            });
          //this.googleMapsService.initMap(this.mapData, 'map_1', this.shouldMapRefresh);
          this.shouldMapRefresh = false

          this.allProduct = {
            ...response,
            data: [...this.allProduct.data, ...response?.data],
          };
          this.cdr.detectChanges();
          // if (this.areProductLoadedForOtherProducts) {
          //    this.googleMapsService.setZoom(1)
          // }
        }


        if (response?.data?.length < 1)
          this.allProduct.currentPage = this.allProduct.lastPage;
        this.isLoadingAllProduct = false;
        this.isLoadingAllProductMore = false;
        this.cdr.detectChanges();

      });
  }

  private loadUserRegionAds(): void {
    const userRegionSubscription = this.store
      .pipe(
        select(selectUser),
        filter((user) => !!user)
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user?.regionName) {
          this.selectedMemberRegion = user.regionName;
          this.getAds('', this.selectedMemberRegion);
        }
      });

    this.subscriptions.push(userRegionSubscription);
  }

  public totalTabs = [
    { title: 'Latest', condition: true },
    { title: 'Rental', condition: true },
    { title: 'Donations', condition: true },
    { title: 'Popular', condition: true },
  ];

  indexFilter: string = 'map';
  usersProducts = []
  areUsersProductsLoading =  false;
  public get isBrowser(){
    return this.sharedService.isBrowser()
  }
  loadUserLoadsProducts(orderBy){

    this.areUsersProductsLoading = true
    this.customerService.getMemberShopProductList({
      orderBy,
      limit: 20,
      isMyProductOnly: true
    }).subscribe({
      next: data =>{
        this.areUsersProductsLoading = false;
        this.usersProducts = data.body.data;
        this.cdr.detectChanges()
      },
      error: ()=>{
        this.areUsersProductsLoading = false;
      }

    })
  }
  updateSelMenu(index: number): void {
    const filters = [
      "latest",
      "rental",
      "donate",
      "popular"
    ]
    this.loadUserLoadsProducts(filters[index])
    // const indexFilter = [
    //   'map',
    //   'shop',
    //   'rental',
    //   'bless',
    //   'popular',
    //   'Technology',
    //   'Education',
    //   'favorites',
    // ];
    // if (this.indexFilter == 'map' || indexFilter[index] == 'map') {
    //   this.shouldMapRefresh = true //when tabs change the div where map is shown is changes so needs redraw otherwise just pan it
    // }

    // if (this.indexFilter != indexFilter[index]) {
    //   //Avoid Spam
    //   this.indexFilter = indexFilter[index];
    //   this.basedProduct =
    //     this.indexFilter == 'shop' ? 'shop_promote' : this.indexFilter;
    //   this.cdr.detectChanges();
    //   if (this.basedProduct == 'favorites') this.getFavoriteProducts();
    //   else this.handleLoadProducts();
    // }


  }

  public allSeparateDoorstepProducts = [];
  public separateDoorstepProducts = [];

  private isFirstLoad = false;

  public showDoorSteps = false;

  private nextDoorStepIndex = 0;
  public loadMoreDoorsteps(page: number = 1) {
    this.isFirstLoad = page == 1;
    this.customerService
      .getMemberShopProductList({
        isDoorstep: true,
        page: page,
        limit: this.deviceType * 2,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        response = response.body;
        if (response.currentPage === 1) this.allProductDoorstep.data = [];
        if (response?.data)
          this.allProductDoorstep = {
            ...response,
            data: [...this.allProductDoorstep.data, ...response?.data],
          };

        this.isFirstLoad = false;
        this.isLoadingDoorstepMore = false;
      });
  }

  sliceArray(array: any[]): any[] {
    return this.isMobile && !this.readMore ? array.slice(0, 5) : array;
  }

  public timeout3: any;
  openShopPopup(name: string): void {
    this.sharedService.triggerInitTabProfile('shop');
    const filterType = {
      bless: 2,
      rental: 1,
      shop: 0,
    };
    this.local.clearTimeout(this.timeout3)
    this.timeout3 = setTimeout(() => {
      this.sharedService.triggerInitMarketProfile(filterType[name]);
    }, 100);
  }

  getAds(category: string, memberShopSubRegion: string): void {
    this.auth
      .getMemberShopAdsBy(category, memberShopSubRegion)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.adsList = resp.body;
      });
  }

  public viewProductDetails(product): void {
    this.marketplacePage.enableMemberShop = true;
    this.marketplacePage.viewProduct(product);
  }
  public isSearchBarVisible = false;
  public isUpperMenuVisible = false;

  handleSearch(event: any): void {
    this.search = event.target.value;
    this.handleLoadProducts();
  }


  public selectedMapCategoryId = 'all';
  public mapSubCategories = []

  public loadMapCategory(selectedCategory: string | any) {
    //needs to accept the categroy object or "all" as string
    if (selectedCategory == 'all') {
      this.mapSubCategories = [];
      this.selectedMapCategoryId = 'all';
    } else {
      this.selectedMapCategoryId = selectedCategory.id;
      this.mapSubCategories = selectedCategory?.subCategory;
      this.mapSubCategories.forEach((subCat) => (subCat.isChecked = true));
      // setTimeout(()=>this.modalService.open(this.selectSubCategories, {windowClass: 'sm'}))
    }

    this.handleLoadProducts();
  }
  public servicesSelectedSubRegion = null;
  public onImgError(error) {
    (
      event.target as HTMLImageElement
    ).style.backgroundImage = `url('../../../../../../assets/images/shop/default.png')`;

  }

  public get categoryId() {

    return (this.selectedMapCategoryId == 'all'
      ? ''
      : ([
        ...this.mapSubCategories
          .filter((sb) => sb.isChecked)
          .map((sb) => sb.categorieChildId),
      ] as any)
    );
  }

  handleLoadProducts(page: number = 1) {
    //selected category id(ints) as array
    const categoryId = this.categoryId
    this.isLoadingAllProduct = page == 1;

    let subRegionId = this.userRegionId;

    // used by the drop down above
    //select the region that is selected by the admin
    if (
      this.roleService?.roles?.userType.includes('ADMIN') &&
      this.servicesSelectedSubRegion
    ) {
      subRegionId = this.servicesSelectedSubRegion;
    }

    if (this.basedProduct == 'popular') {
      this.store.dispatch(
        loadIndividualProducts({
          categoryId,
          isPopular: true,
          subRegionId,
          orderBy: 'points',
          basedProduct: 'all'
        })
      );
    } else if (this.indexFilter == 'map') {


      this.store.dispatch(
        loadIndividualProducts({
          categoryId,
          subRegionId,
          page: page,
          basedProduct: 'shop_promote',
          search: this.search,
          orderBy: 'points',
          loadTags: true
        })
      );
    } else {
      this.store.dispatch(
        loadIndividualProducts({
          categoryId,
          subRegionId,
          search: this.search,
          page: page,
          basedProduct: this.basedProduct,
          orderBy: 'points',
        })
      );
    }
    this.cdr.detectChanges();
  }
}
